import React from 'react';
import './loaderList.scss';

const Loader = () => (<div className="container-loader"><div className="loader" /></div>);

export default Loader;
